import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-enter-email',
  templateUrl: './dialog-enter-email.component.html',
  styleUrls: ['./dialog-enter-email.component.scss']
})
export class DialogEnterEmailComponent implements OnInit {
  email: string;
  constructor() { }

  ngOnInit() {
  }

}
